import ChangePasswordForm from "./ChangePassword";

const formsComponents = {
  ChangePasswordForm
}

export default formsComponents